// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ProviderFacility,
    ProviderFacilityFromJSON,
    ProviderFacilityToJSON,
    ProviderGuarantor,
    ProviderGuarantorFromJSON,
    ProviderGuarantorToJSON,
    ProviderPayer,
    ProviderPayerFromJSON,
    ProviderPayerToJSON,
    ProviderPayerSubscriber,
    ProviderPayerSubscriberFromJSON,
    ProviderPayerSubscriberToJSON,
    ProviderProvider,
    ProviderProviderFromJSON,
    ProviderProviderToJSON,
    ProviderSeller,
    ProviderSellerFromJSON,
    ProviderSellerToJSON,
    ProviderSubscriberPatient,
    ProviderSubscriberPatientFromJSON,
    ProviderSubscriberPatientToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderMedicalClaim
 */
export interface ProviderMedicalClaim {
    /**
     * The guarantor id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderMedicalClaim
     */
    guarantorId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderGuarantor}
     * @type {ProviderGuarantor}
     * @memberof ProviderMedicalClaim
     */
    guarantor?: ProviderGuarantor;
    /**
     * The chargemaster id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderMedicalClaim
     */
    chargemasterId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderPayer}
     * @type {ProviderPayer}
     * @memberof ProviderMedicalClaim
     */
    primaryThirdPartyAdministratorPayer?: ProviderPayer;
    /**
     * 
     * OpenAPI data type: {ProviderPayer}
     * @type {ProviderPayer}
     * @memberof ProviderMedicalClaim
     */
    secondaryThirdPartyAdministratorPayer?: ProviderPayer;
    /**
     * 
     * OpenAPI data type: {ProviderPayer}
     * @type {ProviderPayer}
     * @memberof ProviderMedicalClaim
     */
    tertiaryThirdPartyAdministratorPayer?: ProviderPayer;
    /**
     * The subscriber and the relationship to the payer
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof ProviderMedicalClaim
     */
    payerSubscriberIds: Array<string>;
    /**
     * The subscriber and the relationship to the payer
     * OpenAPI data type: {array}
     * @type {Array<ProviderPayerSubscriber>}
     * @memberof ProviderMedicalClaim
     */
    payerSubscribers?: Array<ProviderPayerSubscriber>;
    /**
     * The patient and the relationship to the subscriber
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof ProviderMedicalClaim
     */
    subscriberPatientIds: Array<string>;
    /**
     * The patient and the relationship to the subscriber
     * OpenAPI data type: {array}
     * @type {Array<ProviderSubscriberPatient>}
     * @memberof ProviderMedicalClaim
     */
    subscriberPatients?: Array<ProviderSubscriberPatient>;
    /**
     * The various types of providers.
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof ProviderMedicalClaim
     */
    providerIds: Array<string>;
    /**
     * The providers
     * OpenAPI data type: {array}
     * @type {Array<ProviderProvider>}
     * @memberof ProviderMedicalClaim
     */
    providers?: Array<ProviderProvider>;
    /**
     * The seller id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderMedicalClaim
     */
    sellerId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderSeller}
     * @type {ProviderSeller}
     * @memberof ProviderMedicalClaim
     */
    seller?: ProviderSeller;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderMedicalClaim
     */
    facilityId?: string;
    /**
     * 
     * OpenAPI data type: {ProviderFacility}
     * @type {ProviderFacility}
     * @memberof ProviderMedicalClaim
     */
    facility?: ProviderFacility;
    /**
     * The claim id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderMedicalClaim
     */
    claimId?: string;
    /**
     * The user id of who created the resource
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderMedicalClaim
     */
    createdBy?: string;
}

export function ProviderMedicalClaimFromJSON(json: any): ProviderMedicalClaim {
    return {
            'guarantorId': !exists(json, 'guarantorId') ? undefined : json['guarantorId'],
            'guarantor': !exists(json, 'guarantor') ? undefined : ProviderGuarantorFromJSON(json['guarantor']),
            'chargemasterId': !exists(json, 'chargemasterId') ? undefined : json['chargemasterId'],
            'primaryThirdPartyAdministratorPayer': !exists(json, 'primaryThirdPartyAdministratorPayer') ? undefined : ProviderPayerFromJSON(json['primaryThirdPartyAdministratorPayer']),
            'secondaryThirdPartyAdministratorPayer': !exists(json, 'secondaryThirdPartyAdministratorPayer') ? undefined : ProviderPayerFromJSON(json['secondaryThirdPartyAdministratorPayer']),
            'tertiaryThirdPartyAdministratorPayer': !exists(json, 'tertiaryThirdPartyAdministratorPayer') ? undefined : ProviderPayerFromJSON(json['tertiaryThirdPartyAdministratorPayer']),
            'payerSubscriberIds': json['payerSubscriberIds'],
            'payerSubscribers': !exists(json, 'payerSubscribers') ? undefined : (json['payerSubscribers'] as Array<any>).map(ProviderPayerSubscriberFromJSON),
            'subscriberPatientIds': json['subscriberPatientIds'],
            'subscriberPatients': !exists(json, 'subscriberPatients') ? undefined : (json['subscriberPatients'] as Array<any>).map(ProviderSubscriberPatientFromJSON),
            'providerIds': json['providerIds'],
            'providers': !exists(json, 'providers') ? undefined : (json['providers'] as Array<any>).map(ProviderProviderFromJSON),
            'sellerId': !exists(json, 'sellerId') ? undefined : json['sellerId'],
            'seller': !exists(json, 'seller') ? undefined : ProviderSellerFromJSON(json['seller']),
            'facilityId': !exists(json, 'facilityId') ? undefined : json['facilityId'],
            'facility': !exists(json, 'facility') ? undefined : ProviderFacilityFromJSON(json['facility']),
            'claimId': !exists(json, 'claimId') ? undefined : json['claimId'],
            'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
    };

}

export function ProviderMedicalClaimToForm(value?: ProviderMedicalClaim): any {
    let jsonVal = ProviderMedicalClaimToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderMedicalClaimToJSON(value?: ProviderMedicalClaim): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'guarantorId': cleanupBlankValuesForBackend(value.guarantorId),
            'guarantor': ProviderGuarantorToJSON(value.guarantor),
            'chargemasterId': cleanupBlankValuesForBackend(value.chargemasterId),
            'primaryThirdPartyAdministratorPayer': ProviderPayerToJSON(value.primaryThirdPartyAdministratorPayer),
            'secondaryThirdPartyAdministratorPayer': ProviderPayerToJSON(value.secondaryThirdPartyAdministratorPayer),
            'tertiaryThirdPartyAdministratorPayer': ProviderPayerToJSON(value.tertiaryThirdPartyAdministratorPayer),
            'payerSubscriberIds': cleanupBlankValuesForBackend(value.payerSubscriberIds),
            'payerSubscribers': (value.payerSubscribers === undefined || value.payerSubscribers === null) ? undefined : (value.payerSubscribers as Array<any>).map(ProviderPayerSubscriberToJSON),
            'subscriberPatientIds': cleanupBlankValuesForBackend(value.subscriberPatientIds),
            'subscriberPatients': (value.subscriberPatients === undefined || value.subscriberPatients === null) ? undefined : (value.subscriberPatients as Array<any>).map(ProviderSubscriberPatientToJSON),
            'providerIds': cleanupBlankValuesForBackend(value.providerIds),
            'providers': (value.providers === undefined || value.providers === null) ? undefined : (value.providers as Array<any>).map(ProviderProviderToJSON),
            'sellerId': cleanupBlankValuesForBackend(value.sellerId),
            'seller': ProviderSellerToJSON(value.seller),
            'facilityId': cleanupBlankValuesForBackend(value.facilityId),
            'facility': ProviderFacilityToJSON(value.facility),
            'claimId': cleanupBlankValuesForBackend(value.claimId),
            'createdBy': cleanupBlankValuesForBackend(value.createdBy),
    };
}


